import useFeatureFlagLoaded from './useFeatureFlagLoaded';

// TODO: Add unit test to hook useFeatureFlag
export default function useFeatureFlag(
  key?: string,
  initialValue?: boolean | string
) {
  return useFeatureFlagLoaded(key, initialValue)[1];
}
